const COUNTRIES = [
  { name: "Koshi", code: "NP-P1" },
  { name: "Madhesh", code: "NP-P2" },
  { name: "Bagmati", code: "NP-P3" },
  { name: "Gandaki", code: "NP-P4" },
  { name: "Lumbini", code: "NP-P5" },
  { name: "Karnali", code: "NP-P6" },
  { name: "Sudurpashchim", code: "NP-P7" }
];

export default COUNTRIES;